import ApplicationRecord from '@/models/application_record'

import {
  Model,
  Attr
} from 'spraypaint'

@Model()
export default class Permission extends ApplicationRecord {
  static jsonapiType = 'permissions'

  @Attr name!: string
}
